import { makeStyles } from "@material-ui/core";

export const PasswordFieldStyles = makeStyles(() => ({
  errorSpan: {
    margin: "4px 14px",
    color: "#f44336",
    fontSize: "0.75rem",
    fontWeight: "400",
  },
  inputIcons: {
    position: "absolute",
    top: "6%",
    left: "58%",
    width: "72px",
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
  },
  checkIcon: {
    color: "#0ABF52",
    paddingLeft: "10px",
    paddingRight: "5px",
  },
  password: {
    paddingRight: "20px",
  },
  list: {
    paddingInlineStart: "20px",
  },
  "@global": {
    "input::-ms-reveal, input::-ms-clear": {
      display: "none",
    },
    "input::-webkit-credentials-auto-fill-button": {
      visibility: "hidden",
    },
  },
}));
